import React from "react";
import Tech1 from "../media/tech-1.png";
import Tech2 from "../media/tech-2.png";
import Tech3 from "../media/tech-3.png";
import Tech4 from "../media/tech-4.png";
import { MdKeyboardArrowRight } from "react-icons/md";

function Tech() {
  return (
    <div className="bg-second">
      <div className="md:container md:mx-auto flex flex-col justify-center items-center">
        <h1 className="text-white mt-16 uppercase font-bold text-2xl inline-block border-b border-second">TEXNİKALAR</h1>
        <div className="cards sm:justify-center flex md:flex-nowrap sm:flex-wrap sm:gap-y-10  md:gap-x-3 my-16">
          <div className="card shadow-xl bg-white">
            <img src={Tech1} alt="" />
            <h1 className="md:text-sm sm:text-md p-3 text-center">Lorem ipsum dolor sit.</h1>
          </div>
          <div className="card shadow-xl bg-white">
            <img src={Tech2} alt="" />
            <h1 className="md:text-sm sm:text-md p-3 text-center">Lorem ipsum dolor sit.</h1>
          </div>
          <div className="card shadow-xl bg-white">
            <img src={Tech3} alt="" />
            <h1 className="md:text-sm sm:text-md p-3 text-center">Lorem ipsum dolor sit.</h1>
          </div>
          <div className="card shadow-xl bg-white">
            <img src={Tech4} alt="" />
            <h1 className="md:text-sm sm:text-md p-3 text-center">Lorem ipsum dolor sit.</h1>
          </div>
        </div>
        <button className="mb-16 flex justify-center rounded-md sm:w-32 md:w-40 text-white bg-first px-7 py-3">
          Hamısı
          <MdKeyboardArrowRight className="ml-3 mb-1 text-2xl" />
        </button>
      </div>
    </div>
  );
}

export default Tech;
